// extracted by mini-css-extract-plugin
export default {"wrap":"PlaceholderPage_wrap__JmmHF","title":"PlaceholderPage_title__2kCyh"};